import analysisModule from "./analysisModule"
import server from "../server"

analysisModule.service("nlgBasketService", ["nlgBasketServiceFactory", function (nlgBasketServiceFactory) {
    return nlgBasketServiceFactory("presentation-tree", server.getBaseUrl())
}])

